export default __webpack_public_path__ + "static/media/pencil_grey.1d5ec3f2.svg";